export default function objectToQueryString(object) {
  let queryString = ''
  for (const param in object) {
    if (!object[param]) continue
    queryString += `&${param}=${object[param]}`
  }
  return queryString.replace('&', '?')
}
